var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.render)?_c('v-system-bar',{staticClass:"px-0",attrs:{"app":_vm.app ? true : false,"height":"48"}},[(_vm.showSubscriptionPastDue)?_c('SubscriptionPastDue'):(_vm.showPrintPromo)?_c('PrintPromo'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }